// GrowVise brand mark: blue tile, rising bars, gold growth arrow.
export const LogoMark = ({ size = 40 }) => (
    <svg width={size} height={size} viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <defs>
            <linearGradient id="gv-tile" x1="0" y1="0" x2="80" y2="80" gradientUnits="userSpaceOnUse">
                <stop offset="0" stopColor="#30478F" />
                <stop offset="1" stopColor="#1C2C63" />
            </linearGradient>
            <linearGradient id="gv-bar" x1="0" y1="20" x2="0" y2="76" gradientUnits="userSpaceOnUse">
                <stop offset="0" stopColor="#6B8FD6" />
                <stop offset="1" stopColor="#4A6DB5" />
            </linearGradient>
        </defs>
        <rect x="1" y="1" width="78" height="78" rx="14" fill="url(#gv-tile)" />
        <rect x="1" y="1" width="78" height="78" rx="14" stroke="#FFFFFF" strokeOpacity="0.08" strokeWidth="1.5" />
        <rect x="14" y="51" width="14" height="22" rx="1.5" fill="url(#gv-bar)" />
        <rect x="33" y="40" width="14" height="33" rx="1.5" fill="url(#gv-bar)" />
        <rect x="52" y="24" width="14" height="49" rx="1.5" fill="url(#gv-bar)" />
        <path d="M16 57 L62 18" stroke="#E6CB7C" strokeWidth="3.2" strokeLinecap="round" />
        <path d="M71 11 L55 15.5 L66.5 26.5 Z" fill="#E6CB7C" />
    </svg>
);

export const Logo = ({ compact = false, header = false }) => (
    <span className="flex items-center gap-3" data-testid="brand-logo">
        <LogoMark size={compact ? 34 : 42} />
        <span className="leading-none">
            <span className="block font-serif font-bold text-[1.45rem] tracking-tight text-slate-50">
                Grow<span className="text-gold-500">Vise</span>
            </span>
            {!compact && (
                <span className={`${header ? "block lg:hidden xl:block" : "block"} mt-1.5 pt-1.5 border-t border-gold-500/50 text-[8.5px] font-sans font-medium tracking-[0.22em] text-slate-300/80 uppercase whitespace-nowrap`}>
                    Commercial Growth &amp; Implementation
                </span>
            )}
        </span>
    </span>
);
